import { createSlice } from '@reduxjs/toolkit';

const INITIAL_PANEL_STATUS = {
  panelOpen: false,
};

const INITIAL_SEARCH_PANEL_STATE = {
  panelStatus: INITIAL_PANEL_STATUS,
  searchBarOpen: false,
};

const SearchPanelV2Slice = createSlice({
  name: 'searchPanel',
  initialState: INITIAL_SEARCH_PANEL_STATE,
  reducers: {
    setPanelStatus: (state, action) => {
      state.panelStatus = { ...state.panelStatus, ...action.payload };
    },
    setSearchBarOpen: (state, action) => {
      state.searchBarOpen = action.payload;
    },
  },
});

export const { setPanelStatus, setSearchBarOpen } = SearchPanelV2Slice.actions;

export default SearchPanelV2Slice.reducer;
